import AccordionSummary from '@mui/material/AccordionSummary';

export { AccordionSummary };
